import gql from 'graphql-tag';
import getGraphQLClient from '../../GraphQL/graphQLClient';
//import graphqlClientFactory from 'lib/graphql-client-factory';
const StateListGLQuery = gql`
  query StateList($rootItemId: String!, $templates: String!, $language: String!, $after: String!) {
    search(
      where: {
        AND: [
          { name: "_path", value: $rootItemId, operator: CONTAINS }
          { name: "_templates", value: $templates, operator: CONTAINS }
          { name: "_language", value: $language }
        ]
      }
      first: 20
      after: $after
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      stateList: results {
        stateName: name
        key: field(name: "key") {
          value
        }
        displayText: field(name: "value") {
          value
        }
        label: field(name: "label") {
          value
        }
        isterritoryState: field(name: "isTerritoryState") {
          value
        }
        countryCodeTerritory: field(name: "cc_TerritoryState") {
          value
        }
      }
    }
  }
`;

const StateListContactFormGLQuery = gql`
  query StateList($rootItemId: String!, $templateId: String!, $language: String!, $after: String!) {
    search(
      where: {
        AND: [
          { name: "_path", value: $rootItemId, operator: EQ }
          { name: "_templates", value: $templateId, operator: EQ }
          { name: "_language", value: $language }
        ]
      }
      after: $after
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      states: results {
        stateName: name
        version
        StateList: field(name: "stateList") {
          jsonValue
        }
      }
    }
  }
`;

export const getStateListGLQueryParameters = (
  language: string,
  countryId: string,
  after: string
) => ({
  //TODO: rootItemId and template should be read from sitecore contect data
  templates: '{371FB8E1-C9DC-4C50-9282-14239BF4862E}',
  rootItemId: countryId || '{0BAEDE80-BEE8-493D-B548-B60A6935A31C}',
  after,
  language,
});

export const getStateListContactFormGLQueryParameters = (
  language: string,
  datasource: string,
  after: string
) => ({
  //TODO: rootItemId and template should be read from sitecore contect data
  templateId: '{EDE0B4AA-64C8-47AE-96BD-EFA4E2E5CDFC}',
  rootItemId: datasource,
  after,
  language,
});

export const getAllStates = async (language: string, countryId: string) => {
  let stateList: any = [];
  let shouldQueryMoreItems = true;
  let after = '';

  while (shouldQueryMoreItems) {
    const graphQLClient = getGraphQLClient();
    const fetchResponse = await graphQLClient.request<any>(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      StateListGLQuery as any,
      getStateListGLQueryParameters(language, countryId, after)
    );
    stateList = stateList.concat(fetchResponse?.search?.stateList);
    shouldQueryMoreItems = fetchResponse.search.pageInfo.hasNext;
    after = fetchResponse.search.pageInfo.endCursor;
  }
  return stateList;
};

/**
 * Maps raw stateListContactInfo response to the standard state list shape.
 * Each entry has StateList.jsonValue (array of state items with name, fields).
 */
function mapStateListContactInfoToStateList(
  stateListContactInfo: Array<{ StateList?: { jsonValue?: any[] } }> | null | undefined
): Array<{
  stateName: string;
  key: { value: string };
  displayText: { value: string };
  label: { value: string };
  isterritoryState: { value: string };
  countryCodeTerritory: { value: string };
}> {
  if (!Array.isArray(stateListContactInfo)) return [];
  const toValue = (v: unknown): string =>
    v != null && typeof v === 'object' && 'value' in v
      ? String((v as { value: unknown }).value ?? '')
      : String(v ?? '');
  const items: any[] = stateListContactInfo.flatMap((entry) => entry?.StateList?.jsonValue ?? []);
  return items.map((state: any) => {
    const stateName = state?.name ?? '';
    const keyVal = toValue(state?.fields?.key);
    const displayVal = toValue(state?.fields?.value);
    const labelVal = toValue(state?.fields?.label) || '';
    const isTerritory = state?.fields?.isTerritoryState?.value === true;
    const ccVal = toValue(state?.fields?.cc_TerritoryState) || '';
    return {
      stateName,
      key: { value: keyVal },
      displayText: { value: displayVal },
      label: { value: labelVal },
      isterritoryState: { value: isTerritory ? '1' : '' },
      countryCodeTerritory: { value: ccVal },
    };
  });
}

export const getAllContactFormStates = async (language: string, datasource: string) => {
  let rawList: any = [];
  let shouldQueryMoreItems = true;
  let after = '';

  while (shouldQueryMoreItems) {
    const graphQLClient = getGraphQLClient();
    const fetchResponse = await graphQLClient.request<any>(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      StateListContactFormGLQuery as any,
      getStateListContactFormGLQueryParameters(language, datasource, after)
    );
    rawList = rawList.concat(fetchResponse?.search?.states);
    shouldQueryMoreItems = fetchResponse.search.pageInfo.hasNext;
    after = fetchResponse.search.pageInfo.endCursor;
  }
  return mapStateListContactInfoToStateList(rawList);
};
export default StateListGLQuery;
